import React from 'react';
import { Helmet } from 'react-helmet-async';
import ValuationTool from './ValuationTool';

// Thin wrapper: the valuation engine lives in ValuationTool (shared with the
// co-branded Westwood Highlands page). This page just supplies the SEO/meta.
function HomeValuation() {
  return (
    <>
      <Helmet>
        <title>Free Home Valuation | Lily Lai Real Estate</title>
        <meta name="description" content="Get a free, AI-powered estimate of your Bay Area home's value with comparable sales in your neighborhood. No commitment required — powered by Lily Lai Real Estate." />
        <link rel="canonical" href="https://www.lilylaisf.com/home-valuation" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.lilylaisf.com/home-valuation" />
        <meta property="og:title" content="Free Home Valuation | Lily Lai Real Estate" />
        <meta property="og:description" content="Get a free AI-powered estimate of your Bay Area home's value with comparable sales in your neighborhood." />
        <meta property="og:image" content="https://res.cloudinary.com/dlaituqwq/image/upload/f_auto,q_auto/v1776298547/Untitled_design_6_naxwl1" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Free Home Valuation | Lily Lai Real Estate" />
        <meta name="twitter:description" content="Get a free AI-powered estimate of your Bay Area home's value with comparable sales in your neighborhood." />
        <meta name="twitter:image" content="https://res.cloudinary.com/dlaituqwq/image/upload/f_auto,q_auto/v1776298547/Untitled_design_6_naxwl1" />
      </Helmet>

      <ValuationTool source="home-valuation" />
    </>
  );
}

export default HomeValuation;
